<template>
  <div class="px-24 md:px-0">
    <h2 class="body-1-bold">{{ i18n(translations.title) }}</h2>
    <h3 class="body-2 mb-40">{{ i18n(translations.subtitle) }}</h3>
  </div>

  <RevAccordionList :hasExternalBorders="false">
    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.howOfferCalculated) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.howOfferCalculatedAnswer) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.devicesEligible) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.devicesEligibleAnswer) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.prepareDevice) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.prepareDeviceAnswer) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.shipDevice) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.shipDeviceAnswer) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.howLongToShip) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.howLongToShipAnswer) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.dataOnDevice) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.dataOnDeviceAnswer) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.payment) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.paymentAnswer) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.deviceAfterTradeIn) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.deviceAfterTradeInAnswer) }}
        </p>
      </template>
    </RevAccordionItem>

    <RevAccordionItem :wrapper-attrs="{ class: 'border-none' }">
      <template #title>
        <h3 class="body-1-bold">{{ i18n(translations.recycling) }}</h3>
      </template>
      <template #body>
        <p class="body-2">
          {{ i18n(translations.recyclingAnswer) }}
        </p>
      </template>
    </RevAccordionItem>
  </RevAccordionList>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevAccordionList } from '@ds/components/AccordionList'

import translations from './FaqBlock.translations'

const i18n = useI18n()
</script>
